import "../../../../shared/css/ElementoPlanoOrcamentoAvaliacao.scss";

import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Tooltip from "@mui/material/Tooltip";

function ElementoOrcamento(props) {
  const {
    tratamento,
    tipoCobertura,
    modalidadePagamento,
    cobertura,
    dente,
    faces,
    show,
    id,
    removeService,
    addService,
    tratamentoNaoCoberto,
    variantes = [],
    onSelecionarFornecedor,
  } = props;

  // Mostrar seletor de fornecedor apenas quando existem várias variantes
  // (mesmo tratamento com fornecedores diferentes) para esta designação.
  const temVariantesFornecedor = variantes.length > 1;

  // Determinar valores a mostrar baseado no tipo de cobertura e modalidade
  const getValorUnitario = () => {
    if (tipoCobertura === "PARTICULAR") {
      return tratamento.preco_particular;
    }

    // Se tem instituição mas o tratamento não é coberto
    if (tratamentoNaoCoberto || !cobertura?.coberto) {
      return tratamento.preco_particular;
    }

    // Se tem cobertura, retorna o preço segurado
    return cobertura.preco_segurado;
  };

  const getValorComparticipacao = () => {
    if (tratamentoNaoCoberto || !cobertura?.coberto) {
      return "";
    }
    return cobertura.comparticipacao;
  };

  const getValorBeneficiario = () => {
    if (tratamentoNaoCoberto || !cobertura?.coberto) {
      return tratamento.preco_particular;
    }

    if (modalidadePagamento === "DIRETO") {
      return cobertura.preco_beneficiario;
    } else {
      // REEMBOLSO
      return cobertura.preco_segurado;
    }
  };

  return (
    <>
      <div>
        <span
          className={`elementoOrcamento__nomeTratamento ${
            !show ? "elementoOrcamento__span__notToShow" : ""
          }`}
        >
          {tratamento.designacao}
          {!temVariantesFornecedor && tratamento.fornecedor?.nome ? (
            <span style={{ display: "block", fontSize: "0.75rem", color: "#9e9e9e" }}>
              {tratamento.fornecedor.nome}
            </span>
          ) : null}
        </span>

        {show && temVariantesFornecedor ? (
          <select
            className="elementoOrcamento__fornecedorSelect"
            value={tratamento.id}
            onChange={(e) =>
              onSelecionarFornecedor && onSelecionarFornecedor(e.target.value)
            }
          >
            {variantes.map((v) => (
              <option key={v.id} value={v.id}>
                {v.fornecedor?.nome || "Sem fornecedor"}
              </option>
            ))}
          </select>
        ) : null}
        <div className="elementoOrcamento__facesEDentes">
          <span
            className={`${!show ? "elementoOrcamento__span__notToShow" : ""}`}
          >
            {dente}{" "}
          </span>
          {faces.length > 0 ? ` - ${faces.join(", ")}` : ""}
        </div>
      </div>

      {/* Coluna Val. Unit. */}
      <span className={`${!show ? "elementoOrcamento__span__notToShow" : ""}`}>
        {Intl.NumberFormat("pt-BR").format(getValorUnitario())}
      </span>

      {/* Colunas adicionais quando tem instituição */}
      {tipoCobertura !== "PARTICULAR" && (
        <>
          {/* Coluna com nome da instituição (comparticipação) */}
          <span
            className={`${!show ? "elementoOrcamento__span__notToShow" : ""}`}
          >
            {getValorComparticipacao() !== ""
              ? Intl.NumberFormat("pt-BR").format(getValorComparticipacao())
              : ""}
          </span>

          {/* Coluna Beneficiário */}
          <span
            className={`${!show ? "elementoOrcamento__span__notToShow" : ""}`}
          >
            {Intl.NumberFormat("pt-BR").format(getValorBeneficiario())}
          </span>
        </>
      )}

      {/* Botões de ação */}
      <div className="elemento-avaliacao-btns-container">
        {show ? (
          <Tooltip title="Remover">
            <button
              className="btn-acoes-avaliacao btn-delete"
              onClick={() => removeService(id)}
            >
              <DeleteIcon className="mdi mdi-delete" />
              <DeleteForeverIcon className="mdi mdi-delete-empty" />
            </button>
          </Tooltip>
        ) : (
          <Tooltip title="Adicionar">
            <button
              className="btn-acoes-avaliacao btn-adicionar"
              onClick={() => addService(id)}
            >
              <AddIcon className="mdi mdi-adicionar" />
              <AddCircleOutlineIcon className="mdi mdi-adicionar-empty" />
            </button>
          </Tooltip>
        )}
      </div>
    </>
  );
}

export default ElementoOrcamento;
